<template>
	<div>
		<el-drawer title="退票规则" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
			@close="close">
			<div class="drawer-content">
				<div class="color-blue">改动前</div>
				<div v-if="data && data.sourceSessionRefundRules" class="MT10">
					退票规则：{{data.sourceSessionRefundRules.refundRuleType == 1 ? '不支持退' : data.sourceSessionRefundRules.refundRuleType == 3 ? '支持退，各个场次进行设置' : '支持退，整场演出进行设置' }}
				</div>
				<template v-if="data && data.sourceSessionRefundRules.refundRuleType == 3">
					<table class="info-table " style="width: 100%;">
						<tr>
							<td class="rule-preview lastLevel" v-if="data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel">
								<div class="item" v-if="data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel.open == 1 " >
								    <div>下单后</div>
								    <template v-if="data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel.unit == 'd'">
								        <template v-if="data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum > 0">{{ data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum }}天的24点以前全额退票</template>
								        <template v-else>当天24点以前全额退票</template>
								    </template>
								    <template v-else>
								        <template v-if="data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum > 0">
								            {{ data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum }}小时以内全额退票
								        </template>							        
								    </template>
								</div>
								<div class="item" v-else>
									<template>不支持下单全额退</template>
								</div>
							</td>
							<td class="rule-preview grayBg" v-if="data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel">
								<div class="item" v-if="data.sourceSessionRefundRules.sessionRefundRules[0].orderLevel.open == 1 " >
								    <div>超过后回到下方规则</div>
								</div>
								<div class="item" v-else>
									<template>不支持下单全额退,回到下方规则</template>
								</div>
							</td>							
						</tr>
					</table>
					<table class="info-table MT10" width="100%"	>
						<thead>
							<tr>
								<th>场次</th>
								<th>开演时间</th>
								<th>购票时间限制</th>
								<th>阶段1</th>
								<th>阶段2</th>
								<th>阶段3</th>
								<th>阶段4</th>
								<th>阶段5</th>
					
							</tr>
						</thead>
						<template v-if="data && data.sourceSessionRefundRules">
							<tr v-for="(t, index) in data.sourceSessionRefundRules.sessionRefundRules" :key="t.sessionId">
								<td>{{t.sessionName}}</td>
								<td>{{t.sessionStartTime}}</td>
								<td>
									<template v-if="t.buyTimeStart || t.buyTimeEnd">
										<p v-if="t.buyTimeStart">起：{{ t.buyTimeStart }}</p>
										<p v-if="t.buyTimeEnd">止：{{ t.buyTimeEnd }}</p>
										<p class="font10">在以上时间段内购票才允许退票</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[0]">
										<p v-if="t.refundRules[0].startTime">起：{{ t.refundRules[0].startTime }}</p>
										<p v-if="t.refundRules[0].endTime">止：{{ t.refundRules[0].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[0].serviceFeeRatio }}%</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[1]">
										<p v-if="t.refundRules[1].startTime">起：{{ t.refundRules[1].startTime }}</p>
										<p v-if="t.refundRules[1].endTime">止：{{ t.refundRules[1].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[1].serviceFeeRatio }}%</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[2]">
										<p v-if="t.refundRules[2].startTime">起：{{ t.refundRules[2].startTime }}</p>
										<p v-if="t.refundRules[2].endTime">止：{{ t.refundRules[2].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[2].serviceFeeRatio }}%</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[3]">
										<p v-if="t.refundRules[3].startTime">起：{{ t.refundRules[3].startTime }}</p>
										<p v-if="t.refundRules[3].endTime">止：{{ t.refundRules[3].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[3].serviceFeeRatio }}%</p>
									</template>
									<div>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[4]">
										<p v-if="t.refundRules[4].startTime">起：{{ t.refundRules[4].startTime }}</p>
										<p v-if="t.refundRules[4].endTime">止：{{ t.refundRules[4].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[4].serviceFeeRatio }}%</p>
									</template>
									<div>
										暂未设置
									</div>
								</td>
							</tr>
						</template>
					</table>
					
				</template>
				
				<template v-if="data && data.sourceSessionRefundRules.refundRuleType == 2">
					<el-card class="MT20">
						<div>规则预览</div>
						<table class="info-table MT10" style="width: 100%;" v-if="data.sourceSessionRefundRules.refundRule">
							<tr>
								<td class="rule-preview lastLevel" v-if="data.sourceSessionRefundRules.refundRule.orderLevel">
									<div class="item" v-if="data.sourceSessionRefundRules.refundRule.orderLevel.open == 1 " >
									    <div><!-- {{formData.refundRule.orderLevel.node == 1 ? '下单后' : '开票后'}}  -->下单后</div>
									    <template v-if="data.sourceSessionRefundRules.refundRule.orderLevel.unit == 'd'">
									        <template v-if="data.sourceSessionRefundRules.refundRule.orderLevel.timeNum > 0">{{ data.sourceSessionRefundRules.refundRule.orderLevel.timeNum }}天的24点以前全额退票</template>
									        <template v-else>当天24点以前全额退票</template>
									    </template>
									    <template v-else>
									        <template v-if="data.sourceSessionRefundRules.refundRule.orderLevel.timeNum > 0">
									            {{ data.sourceSessionRefundRules.refundRule.orderLevel.timeNum }}小时以内全额退票
									        </template>							        
									    </template>
									</div>
									<div class="item" v-else>
										<template>不支持下单全额退</template>
									</div>
								</td>
								<td class="rule-preview grayBg" v-if="data.sourceSessionRefundRules.refundRule.orderLevel">
									<div class="item" v-if="data.sourceSessionRefundRules.refundRule.orderLevel.open == 1 " >
									    <div>超过后回到下方规则</div>
									</div>
									<div class="item" v-else>
										<template>不支持下单全额退</template>
									</div>
								</td>	
								<td rowspan="2" class="rule-preview firstLevel" v-if="data.sourceSessionRefundRules.refundRule.firstLevel">
									<div class="item">
									    <div>开演前</div>
									    <template v-if="data.sourceSessionRefundRules.refundRule.firstLevel.unit == 'd'">
									        <template v-if="data.sourceSessionRefundRules.refundRule.firstLevel.timeNum > 0">{{ data.sourceSessionRefundRules.refundRule.firstLevel.timeNum }}天的0点以后不支持退票</template>
									        <template v-else>开演当天0点以后不支持退票</template>
									    </template>
									    <template v-else>
									        <template v-if="data.sourceSessionRefundRules.refundRule.firstLevel.timeNum > 0">
									            {{ data.sourceSessionRefundRules.refundRule.firstLevel.timeNum }}小时以内不支持退票
									        </template>
									        <template v-else>直到开演后才不支持退票</template>
									    </template>
									</div>
								</td>	
							</tr>
							<tr>
								<td class="rule-preview lastLevel" v-if="data.sourceSessionRefundRules.refundRule.lastLevel">
									<div class="item" v-if="data.sourceSessionRefundRules.refundRule.lastLevel.open == 1 ">
									    <div>开票后 <!-- {{formData.refundRule.lastLevel.node == 1 ? '下单后' : '开票后'}} --></div>
									    <template v-if="data.sourceSessionRefundRules.refundRule.lastLevel.unit == 'd'">
									        <template v-if="data.sourceSessionRefundRules.refundRule.lastLevel.timeNum > 0">{{ data.sourceSessionRefundRules.refundRule.lastLevel.timeNum }}天的24点以前全额退票</template>
									        <template v-else>当天24点以前全额退票</template>
									    </template>
									    <template v-else>
									        <template v-if="data.sourceSessionRefundRules.refundRule.lastLevel.timeNum > 0">
									            {{ data.sourceSessionRefundRules.refundRule.lastLevel.timeNum }}小时以内全额退票
									        </template>
									        
									    </template>
									</div>
									<div class="item" v-else>
										<template>不支持全额退票</template>
									</div>
								</td>
								<td class="rule-preview middleLevel">
									<div class="item ">
									    <div>前面{{data.sourceSessionRefundRules.refundRule.middleLevel[0].timeNum}}%时间段扣{{data.sourceSessionRefundRules.refundRule.middleLevel[0].feeRatio}}%</div>
									    <div>中间{{data.sourceSessionRefundRules.refundRule.middleLevel[1].timeNum}}%时间段扣{{data.sourceSessionRefundRules.refundRule.middleLevel[1].feeRatio}}%</div>
									    <div>后面{{data.sourceSessionRefundRules.refundRule.middleLevel[2].timeNum}}%时间段扣{{data.sourceSessionRefundRules.refundRule.middleLevel[2].feeRatio}}%</div>
									</div>
								</td>						
							</tr>
							
							
						</table>
					</el-card>
									
				</template>
				<div class="MT20 color-danger">改动后</div>
				<div v-if="data && data.currentSessionRefundRules" class="MT10">
					退票规则：{{data.currentSessionRefundRules.refundRuleType == 1 ? '不开放' : data.currentSessionRefundRules.refundRuleType == 3 ? '支持退，各个场次进行设置' : '支持退，整场演出进行设置' }}
				</div>
				<template v-if="data && data.currentSessionRefundRules.refundRuleType == 2">					
					<el-card class="MT20">						
						<div>规则预览</div>
						<table class="info-table MT10" style="width: 100%;" v-if="data.currentSessionRefundRules.refundRule">
							<tr>
								<td class="rule-preview lastLevel" v-if="data.currentSessionRefundRules.refundRule.orderLevel">
									<div class="item" v-if="data.currentSessionRefundRules.refundRule.orderLevel.open == 1 " >
									    <div><!-- {{formData.refundRule.orderLevel.node == 1 ? '下单后' : '开票后'}}  -->下单后</div>
									    <template v-if="data.currentSessionRefundRules.refundRule.orderLevel.unit == 'd'">
									        <template v-if="data.currentSessionRefundRules.refundRule.orderLevel.timeNum > 0">{{ data.currentSessionRefundRules.refundRule.orderLevel.timeNum }}天的24点以前全额退票</template>
									        <template v-else>当天24点以前全额退票</template>
									    </template>
									    <template v-else>
									        <template v-if="data.currentSessionRefundRules.refundRule.orderLevel.timeNum > 0">
									            {{ data.currentSessionRefundRules.refundRule.orderLevel.timeNum }}小时以内全额退票
									        </template>							        
									    </template>
									</div>
									<div class="item" v-else>
										<template>不支持下单全额退</template>
									</div>
								</td>
								<td class="rule-preview grayBg" v-if="data.currentSessionRefundRules.refundRule.orderLevel">
									<div class="item" v-if="data.currentSessionRefundRules.refundRule.orderLevel.open == 1 " >
									    <div>超过后回到下方规则</div>
									</div>
									<div class="item" v-else>
										<template>不支持下单全额退</template>
									</div>
								</td>	
								<td rowspan="2" class="rule-preview firstLevel"  v-if="data.currentSessionRefundRules.refundRule.firstLevel">
									<div class="item">
									    <div>开演前</div>
									    <template v-if="data.currentSessionRefundRules.refundRule.firstLevel.unit == 'd'">
									        <template v-if="data.currentSessionRefundRules.refundRule.firstLevel.timeNum > 0">{{ data.currentSessionRefundRules.refundRule.firstLevel.timeNum }}天的0点以后不支持退票</template>
									        <template v-else>开演当天0点以后不支持退票</template>
									    </template>
									    <template v-else>
									        <template v-if="data.currentSessionRefundRules.refundRule.firstLevel.timeNum > 0">
									            {{ data.currentSessionRefundRules.refundRule.firstLevel.timeNum }}小时以内不支持退票
									        </template>
									        <template v-else>直到开演后才不支持退票</template>
									    </template>
									</div>
								</td>	
							</tr>
							<tr>
								<td class="rule-preview lastLevel" v-if="data.currentSessionRefundRules.refundRule.lastLevel">
									<div class="item" v-if="data.currentSessionRefundRules.refundRule.lastLevel.open == 1 ">
									    <div>开票后 <!-- {{formData.refundRule.lastLevel.node == 1 ? '下单后' : '开票后'}} --></div>
									    <template v-if="data.currentSessionRefundRules.refundRule.lastLevel.unit == 'd'">
									        <template v-if="data.currentSessionRefundRules.refundRule.lastLevel.timeNum > 0">{{ data.currentSessionRefundRules.refundRule.lastLevel.timeNum }}天的24点以前全额退票</template>
									        <template v-else>当天24点以前全额退票</template>
									    </template>
									    <template v-else>
									        <template v-if="data.currentSessionRefundRules.refundRule.lastLevel.timeNum > 0">
									            {{ data.currentSessionRefundRules.refundRule.lastLevel.timeNum }}小时以内全额退票
									        </template>
									        
									    </template>
									</div>
									<div class="item" v-else>
										<template>不支持全额退票</template>
									</div>
								</td>
								<td class="rule-preview middleLevel">
									<div class="item ">
									    <div>前面{{data.currentSessionRefundRules.refundRule.middleLevel[0].timeNum}}%时间段扣{{data.currentSessionRefundRules.refundRule.middleLevel[0].feeRatio}}%</div>
									    <div>中间{{data.currentSessionRefundRules.refundRule.middleLevel[1].timeNum}}%时间段扣{{data.currentSessionRefundRules.refundRule.middleLevel[1].feeRatio}}%</div>
									    <div>后面{{data.currentSessionRefundRules.refundRule.middleLevel[2].timeNum}}%时间段扣{{data.currentSessionRefundRules.refundRule.middleLevel[2].feeRatio}}%</div>
									</div>
								</td>						
							</tr>
							
							
						</table>
					</el-card>
				
				</template>
				<template v-if="data && data.currentSessionRefundRules.refundRuleType ==3 ">
					<!-- <el-form-item label="规则预览:"> -->
						<table class="info-table " style="width: 100%;" v-if="data.currentSessionRefundRules.sessionRefundRules[0]">
							<tr>
								<td class="rule-preview lastLevel" v-if="data.currentSessionRefundRules.sessionRefundRules[0].orderLevel">
									<div class="item" v-if="data.currentSessionRefundRules.sessionRefundRules[0].orderLevel.open == 1 " >
									    <div>下单后</div>
									    <template v-if="data.currentSessionRefundRules.sessionRefundRules[0].orderLevel.unit == 'd'">
									        <template v-if="data.currentSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum > 0">{{ data.currentSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum }}天的24点以前全额退票</template>
									        <template v-else>当天24点以前全额退票</template>
									    </template>
									    <template v-else>
									        <template v-if="data.currentSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum > 0">
									            {{ data.currentSessionRefundRules.sessionRefundRules[0].orderLevel.timeNum }}小时以内全额退票
									        </template>							        
									    </template>
									</div>
									<div class="item" v-else>
										<template>不支持下单全额退</template>
									</div>
								</td>
								<td class="rule-preview grayBg"  v-if="data.currentSessionRefundRules.sessionRefundRules[0].orderLevel">
									<div class="item" v-if="data.currentSessionRefundRules.sessionRefundRules[0].orderLevel.open == 1 " >
									    <div>超过后回到下方规则</div>
									</div>
									<div class="item" v-else>
										<template>不支持下单全额退,回到下方规则</template>
									</div>
								</td>	
								
							</tr>
							
							
							
						</table>
					<!-- </el-form-item> -->
					<table class="info-table MT10" width="100%">
						<thead>
							<tr>
								<th>场次</th>
								<th>开演时间</th>
								<th>购票时间限制</th>
								<th>阶段1</th>
								<th>阶段2</th>
								<th>阶段3</th>
								<th>阶段4</th>
								<th>阶段5</th>
					
							</tr>
						</thead>
						<template v-if="data && data.currentSessionRefundRules">
							<tr v-for="(t, index) in data.currentSessionRefundRules.sessionRefundRules" :key="t.sessionId">
								<td>{{t.sessionName}}</td>
								<td>{{t.sessionStartTime}}</td>
								<td>
									<template v-if="t.buyTimeStart || t.buyTimeEnd">
										<p v-if="t.buyTimeStart">起：{{ t.buyTimeStart }}</p>
										<p v-if="t.buyTimeEnd">止：{{ t.buyTimeEnd }}</p>
										<p class="font10">在以上时间段内购票才允许退票</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[0]">
										<p v-if="t.refundRules[0].startTime">起：{{ t.refundRules[0].startTime }}</p>
										<p v-if="t.refundRules[0].endTime">止：{{ t.refundRules[0].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[0].serviceFeeRatio }}%</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[1]">
										<p v-if="t.refundRules[1].startTime">起：{{ t.refundRules[1].startTime }}</p>
										<p v-if="t.refundRules[1].endTime">止：{{ t.refundRules[1].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[1].serviceFeeRatio }}%</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[2]">
										<p v-if="t.refundRules[2].startTime">起：{{ t.refundRules[2].startTime }}</p>
										<p v-if="t.refundRules[2].endTime">止：{{ t.refundRules[2].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[2].serviceFeeRatio }}%</p>
									</template>
									<div v-else>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[3]">
										<p v-if="t.refundRules[3].startTime">起：{{ t.refundRules[3].startTime }}</p>
										<p v-if="t.refundRules[3].endTime">止：{{ t.refundRules[3].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[3].serviceFeeRatio }}%</p>
									</template>
									<div>
										暂未设置
									</div>
								</td>
								<td>
									<template v-if="t.refundRules[4]">
										<p v-if="t.refundRules[4].startTime">起：{{ t.refundRules[4].startTime }}</p>
										<p v-if="t.refundRules[4].endTime">止：{{ t.refundRules[4].endTime }}</p>
										<p class="font10">在以上时间段内申请退票，扣手续费：{{ t.refundRules[4].serviceFeeRatio }}%</p>
									</template>
									<div>
										暂未设置
									</div>
								</td>
							</tr>
						</template>
					</table>
				</template>
				

			</div>
			<div class="drawer-footer">
				<el-button @click="close">关闭</el-button>

			</div>
		</el-drawer>


	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				drawerShow: false,
				dataLoading: false,
				btnLoading: false,
				data: null

			};
		},
		mounted() {

		},
		methods: {
			close() {
				this.drawerShow = false
			},
			show(data) {
				this.data = data
				this.drawerShow = true;

			},
		},
	};
</script>

<style lang="scss" scoped>
.timeline-main-item{
    display: flex;
    align-items: center;
    .el-form-item{
        flex: 1;
        .el-select .el-input{
            min-width: auto;
        }
    }
    .el-input-number{
        margin:0 10px;
    }
    ::v-deep .el-form-item__content{
        font-size: 12px;
        display: flex;
        align-items: center;
        line-height: normal;
    }
    ::v-deep .el-input-number--mini{
        width: auto;
        flex: 1;
        min-width: 80px;
    }
}
::v-deep .el-timeline-item__timestamp{
    color: #333;
}
 .info-table tr td{
	padding:0
}
::v-deep .info-table tr th{
	padding:5px 0 5px 20px
}
::v-deep .el-card__header{
	padding:10px 20px;
	
}
.rule-preview{	
	color: #fff;
	border: none;
	border-bottom: 2px solid #eee;	
    .item{
		padding:10px;
        
        font-size: 12px;
        line-height: normal;
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;
    }
    &.lastLevel{
        background-color: $--color-success;
    }
    &.middleLevel{
        background-color: $--color-warning;
    }
    &.firstLevel{
        background-color: $--color-danger;
    }
	&.grayBg{
		background-color: #999;
		color:#333
	}
}
.hand{
	cursor: pointer;
}
td{
	border-right:1px solid #eee;
}
td:last-child{
	
}
.font10{
	margin-top: 8px;
	font-size: 10px;
}
::v-deep .el-card__body{
	padding:5px
}
</style>